import FilterUtil from "@/plugins/filter-util/FilterUtil";

/**
 * VueにプラグインとしてFilterUtilインスタンスを持たせる
 */
export default {
  install(Vue: any, options: any) {
    Vue.prototype.$filterUtil = new FilterUtil();
  }
};

/**
 * Vueの型定義にFilterUtilを追加する
 */
declare module "vue/types/vue" {
  interface Vue {
    $filterUtil: FilterUtil;
  }
  interface VueConstructor {
    $filterUtil: FilterUtil;
  }
}
